import { render, staticRenderFns } from "./tableread.vue?vue&type=template&id=0e3d4daf&scoped=true"
import script from "./tableread.vue?vue&type=script&lang=js"
export * from "./tableread.vue?vue&type=script&lang=js"
import style0 from "./tableread.vue?vue&type=style&index=0&id=0e3d4daf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3d4daf",
  null
  
)

export default component.exports